/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ERepairshopStatus = 'Activated' | 'Deactivated' | 'Deleted';

export const ERepairshopStatus = {
    Activated: 'Activated' as ERepairshopStatus,
    Deactivated: 'Deactivated' as ERepairshopStatus,
    Deleted: 'Deleted' as ERepairshopStatus
};

